import styled, { css } from 'styled-components';
import { device, hexToRGB, typography } from '@/styles/helpers';

export const ScStepsSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  & .text-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
    & .title {
      ${typography.headline2};
      text-transform: uppercase;
    }
    & .description {
      ${typography.body1regular};
      letter-spacing: 0;
      color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
    }
  }

  & .containers-wrapper {
    display: flex;
    flex-direction: column;
    gap: 80px;
  }

  @media (${device.tablet}) {
    gap: 48px;
    & .text-wrapper {
      gap: 12px;
    }
    & .containers-wrapper {
      gap: 48px;
    }
  }

  @media (${device.mobileS}) {
    gap: 48px;
    & .text-wrapper {
      gap: 12px;
    }
    & .containers-wrapper {
      gap: 32px;
    }
  }
`;

export const ScStepsBenefitsContainer = styled.div<{
  $isOneCol?: boolean;
}>`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  gap: 24px;

  @media (${device.tablet}) {
    & .benefits-img {
      width: 400px;
      height: 300px;
    }
  }

  @media (${device.mobile}) {
    justify-items: center;
    & .benefits-img {
      width: 268px;
      height: 200px;
    }
  }

  ${({ $isOneCol }) =>
    $isOneCol &&
    css`
      @media (max-width: 800px) {
        grid-template-columns: 1fr;
      }
    `}

  @media (${device.mobileS}) {
    grid-template-columns: 1fr;
    & .benefits-img {
      width: 268px;
      height: 200px;
    }
  }
`;
